import { useState, useCallback } from "react";

export const useModuleAssessmentSelection = () => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const toggleOption = useCallback((optionValue: string) => {
    setSelectedOptions((prev) =>
      prev.includes(optionValue)
        ? prev.filter((value) => value !== optionValue)
        : [...prev, optionValue]
    );
  }, []);

  return { selectedOptions, toggleOption };
};
